import { supabase } from '@/lib/supabase'
import { normalizeLinkedOpportunityId } from '../utils/normalizeLinkedOpportunityId'

export async function fetchLinkedOpportunityAnalysisCount(params: {
  opportunityId: number
  excludeAnalysisId?: number | null
}): Promise<number> {
  const opportunityId = normalizeLinkedOpportunityId(params.opportunityId)
  if (!opportunityId) return 0

  const excludeId =
    params.excludeAnalysisId != null && Number.isFinite(Number(params.excludeAnalysisId))
      ? Math.floor(Number(params.excludeAnalysisId))
      : null

  let query = supabase
    .from('market_analyses' as any)
    .select('id', { count: 'exact' })
    .eq('linked_opportunity_id', opportunityId)

  if (excludeId) {
    query = query.neq('id', excludeId)
  }

  const { data, count, error } = await query

  if (error) {
    throw error
  }

  if (typeof count === 'number') return count
  return Array.isArray(data) ? data.length : 0
}

export async function fetchLinkedOpportunityAnalysisCounts(params: {
  opportunityIds: number[]
  excludeAnalysisId?: number | null
}): Promise<Record<number, number>> {
  const idsSet = new Set<number>()
  for (const rawId of params.opportunityIds || []) {
    const id = normalizeLinkedOpportunityId(rawId)
    if (id) idsSet.add(id)
  }
  const ids = Array.from(idsSet)
  if (ids.length === 0) return {}

  const excludeId =
    params.excludeAnalysisId != null && Number.isFinite(Number(params.excludeAnalysisId))
      ? Math.floor(Number(params.excludeAnalysisId))
      : null

  let query = supabase
    .from('market_analyses' as any)
    .select('id,linked_opportunity_id')
    .in('linked_opportunity_id', ids as any)

  if (excludeId) {
    query = query.neq('id', excludeId)
  }

  const { data, error } = await query
  if (error) {
    throw error
  }

  const counts: Record<number, number> = {}
  for (const row of (data || []) as Array<{ linked_opportunity_id?: number | null }>) {
    const oppId = normalizeLinkedOpportunityId(row?.linked_opportunity_id ?? null)
    if (!oppId) continue
    counts[oppId] = (counts[oppId] || 0) + 1
  }

  return counts
}
